import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Custom Modules
import { ShareModule } from './share/share.module';
// Activates
import { ActivateMain, ActivateApplicationsHome } from './activates';
// components
import { MainComponent } from './main/main.component';
@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        ShareModule.forRoot()

    ],
    declarations: [
        MainComponent
    ],
    providers: [],
    exports: [
        BrowserAnimationsModule,
        ShareModule]
})
export class AppCoreModule {
    static forRoot() {   // pattern for adding app-wide services
        return {
            ngModule: AppCoreModule,
            providers: [
                ActivateMain,
                ActivateApplicationsHome
            ],
        };
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/app.core.module.ts